<template>
<div>
    <div id="Navi">
        <div class="sub-box">
            <ul>
                <li><strong><a href="/company" v-bind:title="$t('tlCompany')" :class="selectedid == 'tlCompany' ? 'active': ''" v-on:click="clickMenu('company')">{{$t('tlCompany')}}</a></strong></li>
                <li><strong><a href="/products" v-bind:title="$t('tlProductCenter')" :class="selectedid == 'tlProductCenter' ? 'active': ''">{{$t('tlProductCenter')}}</a></strong></li>
                <li><strong><a href="/service" v-bind:title="$t('tlService')" :class="selectedid == 'tlService' ? 'active': ''" v-on:click="clickMenu('service')">{{$t('tlService')}}</a></strong></li>
                <li><strong><a href="/media" v-bind:title="$t('tlMediaCenter')" :class="selectedid == 'tlMediaCenter' ? 'active': ''" v-on:click="clickMenu('media')">{{$t('tlMediaCenter')}}</a></strong></li>
                <li><strong><a href="mailto:info@arivotyre.com?subject=Test Email" v-bind:title="$t('tlContact')" class="ico-mail">{{$t('tlContact')}}</a></strong></li>
            </ul>
        </div>
    </div>
</div>
</template>

<script>
import $ from 'jquery'
export default {
    name: "Navi",
    props: ['selectedid'],
    methods:{
        clickMenu(className){
            $('body').attr('class', className);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/navi.vue